import { render, staticRenderFns } from "./FlatpageLegalBase.vue?vue&type=template&id=af8e3324&scoped=true&"
import script from "./FlatpageLegalBase.vue?vue&type=script&lang=ts&"
export * from "./FlatpageLegalBase.vue?vue&type=script&lang=ts&"
import style0 from "./FlatpageLegalBase.vue?vue&type=style&index=0&id=af8e3324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8e3324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af8e3324', component.options)
    } else {
      api.reload('af8e3324', component.options)
    }
    module.hot.accept("./FlatpageLegalBase.vue?vue&type=template&id=af8e3324&scoped=true&", function () {
      api.rerender('af8e3324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/FlatpageLegalBase.vue"
export default component.exports